export const getPlaceholderImage = (
  width,
  height,
  bgColor = "2a2e45",
  textColor = "FFF",
  text = "Image",
) => {
  return `https://placehold.co/${width}x${height}/${bgColor}/${textColor}?text=${text}`;
};

export const PLACEHOLDER_IMAGES = {
  CARD: getPlaceholderImage(400, 250),
  PRODUCT: getPlaceholderImage(500, 400),
  PROVIDER: getPlaceholderImage(600, 380),
};
